jQuery(document).ready(function ($) {
  function renderProduct(products) {
    const productsHTML = [];
    const productThumbTemplateHTML = $("#product-thumb-template").html();

    products.forEach((product, index) => {
      const title = product["title"]["rendered"]
        ? product["title"]["rendered"]
        : product["title"];
      const packshot =
        product["images"] && product["images"]["packshot"]
          ? product["images"]["packshot"]["url"]
          : "";
      const alt =
        product["images"]["packshot"] &&
        product["images"]["packshot"]["original_image"]
          ? product["images"]["packshot"]["original_image"]["alt"]
          : `Embalagem do produto ${title}`;

      productsHTML.push(
        productThumbTemplateHTML
          .replace(/{{title}}/g, title)
          .replace(/{{link}}/g, product["link"])
          .replace(/{{alt}}/g, alt)
          .replace(/{{img}}/g, packshot)
          .replace(/{{productId}}/g, product["id"])
          .replace(/{{productId}}/g, product["id"])
          .replace(/{{trackingEvent}}/g, "home-products-list")
          .replace(/{{trackingData}}/g, `{"item_name": "${title}"}`)
      );
    });

    jQuery(".products-list-on-demand .product-list-carrousel")
      .html(productsHTML.join(""))
      .slick(
        {
          arrows: true,
          dots: true,
          dotsClass: "slick-dots-pdp",
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: false,
          prevArrow:
            '<button aria-label="Previous" class="slick-prev-black"></button>',
          nextArrow:
            '<button aria-label="Next" class="slick-next-black"></button>',
          responsive: [
            {
              breakpoint: 1050,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 999,
              settings: {
                slidesToShow: 2.6,
                arrows: false,
              },
            },
            {
              breakpoint: 760,
              settings: {
                slidesToShow: 1.6,
                arrows: false,
              },
            },
            {
              breakpoint: 450,
              settings: {
                slidesToShow: 1,
                arrows: true,
              },
            },
          ],
        },
        1000
      );
  }

  jQuery(".product-list-tab-button").each(function () {
    jQuery(this).on("click", () => {
      jQuery(".product-list-tab-button").removeClass("active");
      jQuery(this).addClass("active");
      let index = jQuery(this).data("index");
      const products = productsListData["products_list"][index]["products"];

      jQuery(".products-list-on-demand .product-list-carrousel")
        .slick("unslick")
        .html("");
      renderProduct(products);

      let numberCards = jQuery(
        ".products-list-on-demand .product-list-carrousel .product-thumb"
      ).length;
      setTimeout(() => {
        if (numberCards <= 4 && window.innerWidth >= 992) {
          jQuery(".products-list-on-demand .product-list-carrousel").slick(
            "unslick"
          );
        }
      }, 1200);
    });
  });

  jQuery(".products-list-on-demand .product-list-carrousel").slick(
    {
      arrows: true,
      dots: true,
      dotsClass: "slick-dots-pdp",
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
      prevArrow: '<button aria-label="Previous" class="slick-prev-black"></button>',
      nextArrow: '<button aria-label="Next" class="slick-next-black"></button>',
      responsive: [
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2.6,
            arrows: false,
          },
        },
        {
          breakpoint: 760,
          settings: {
            slidesToShow: 1.6,
            arrows: false,
          },
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            arrows: true,
          },
        },
      ],
    },
    1000
  );
});

jQuery(document).ready(function ($) {
  let numberCards = jQuery(
    ".products-list-on-demand .product-list-carrousel .product-thumb"
  ).length;
  setTimeout(() => {
    if ((numberCards <= 4) & (window.innerWidth >= 991)) {
      jQuery(".products-list-on-demand .product-list-carrousel").slick(
        "unslick"
      );
    }
  }, 1200);
});
